var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChipWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37334 14.7703L8.5 2.51615L14.6267 14.7703H2.37334Z",
    fill: "#FFB41F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37334 14.7703L8.5 2.51615L14.6267 14.7703H2.37334Z",
    fill: "#FFB41F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 15.3516L8.99944 0.351562H8.00056L0.5 15.3516L0.999436 16.3516H16.0006L16.5 15.3516ZM8.5 2.51615L2.37334 14.7703H14.6267L8.5 2.51615Z",
    fill: "#FFB41F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84863 13.0124C7.84863 12.6253 8.13827 12.3115 8.49555 12.3115H8.50418C8.86147 12.3115 9.1511 12.6253 9.1511 13.0124C9.1511 13.3994 8.86147 13.7132 8.50418 13.7132H8.49555C8.13827 13.7132 7.84863 13.3994 7.84863 13.0124Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09334 5.80859L9.09334 11.6294L7.87988 11.6294L7.87988 5.80859L9.09334 5.80859Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipWarning);
export default __webpack_public_path__ + "static/media/chip_warning.b22de42674fbd29b2a949e325a52a832.svg";
export { ForwardRef as ReactComponent };